import { ChangeDetectorRef, Pipe, PipeTransform, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
  FieldDefinition,
  FormDeclaration,
  ValidationMessageOpts,
} from '@fmnts/declarative-forms/core';
import { LocaleService, TranslationService } from '@fmnts/i18n';

@Pipe({
  name: 'declarativeErrorMessage',
  pure: false,
  standalone: true,
})
export class ErrorMessagePipe implements PipeTransform {
  private readonly cd = inject(ChangeDetectorRef);
  private readonly translationService = inject(TranslationService);
  private readonly localeId = inject(LocaleService).localeId;
  private readonly msgBuilder = inject(
    DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
    { optional: true },
  );

  constructor() {
    // Update components with OnPush change detection strategy
    this.translationService.currentLanguage$
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.cd.markForCheck();
      });
  }

  transform(
    errors: { [key: string]: any },
    field: FieldDefinition,
    declaration: FormDeclaration,
    formatting: Partial<ValidationMessageOpts['formatting']> = {},
  ): string | null {
    return (
      this.msgBuilder?.getMessage(errors, {
        field,
        declaration,
        formatting: {
          currency: undefined,
          locale: this.localeId(),
          ...formatting,
        },
      }) ?? null
    );
  }
}
